import { defineStore } from 'pinia';
import ApiService from '@common/services/api.service';
import { useToastStore} from "@common/store/feature/toast/toast";

export const useDefinitionApplicationStore = defineStore('definitionApplication', {
    state: () => ({
        definitionApplication: null as DefinitionApplication | null,
    }),
    actions: {
        async chargerDefinitionApplication() {
            if (this.definitionApplication !== null) {
                return;
            }

            try {
                const response = await ApiService.get<DefinitionApplication>('/auth/definition-application');
                this.definitionApplication = response.data;
            } catch (error) {
                useToastStore().ajouter({
                    text: 'Erreur lors du chargement de la définition de l\'application',
                    color: 'error',
                });
                console.error('Erreur lors du chargement de la définition de l\'application:', error);
            }
        },
    },
});
